import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared/modules/shared/shared.module';
import { CreateOrganisationComponent } from '../../components/create-organisation/create-organisation.component';
import { ManageOrganisationsComponent } from '../../components/manage-organisations/manage-organisations.component';

const declarations = [ManageOrganisationsComponent, CreateOrganisationComponent];

@NgModule({
  imports: [CommonModule, SharedModule],
  declarations,
  exports: declarations,
})
export class OrganisationModule {}
